/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { identity } from 'lodash';

import { CheckboxTreeNode } from './checkbox-tree-node';

import { normalizeNode } from './checkbox-tree-util';
import { CheckboxTreeService } from './checkbox-tree.service';

@Component({
  selector: 'gh-checkbox-tree-item',
  template: require('./checkbox-tree-item.component.html'),
  styles: [require('./checkbox-tree-item.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxTreeItemComponent<T> implements OnInit {
  @Input() node: CheckboxTreeNode<T>;
  @Input() disabled: boolean;
  @Input() trackBy: TransformFn<T, any> = identity;

  // tslint:disable-next-line:no-output-named-after-standard-event
  @Output() change = new EventEmitter<CheckboxTreeNode<T>>();

  @ViewChildren(CheckboxTreeItemComponent) children: QueryList<CheckboxTreeItemComponent<T>>;

  collapsed: boolean = true;

  constructor(private checkboxTreeService: CheckboxTreeService,
              private changeDetector: ChangeDetectorRef) {
    this.trackByNode = this.trackByNode.bind(this);
  }

  ngOnInit(): void {
    normalizeNode(this.node);
  }

  onToggleCheckbox(event: MatCheckboxChange): void {
    this.toggle(event.checked);

    this.change.emit(this.node);
    this.checkboxTreeService.change.emit(this.node);
  }

  onFoldToggle(): void {
    this.fold(this.collapsed);
  }

  onChangeChild(): void {
    normalizeNode(this.node);

    this.change.emit(this.node);
  }

  fold(expanded: boolean): void {
    this.collapsed = !expanded;

    this.changeDetector.markForCheck();
  }

  foldAll(expanded: boolean): void {
    this.fold(expanded);
    this.children.forEach((child) => child.fold(expanded));
  }

  toggle(checked?: boolean): void {
    this.node.checked = typeof checked === 'boolean' ? checked : !this.node.checked;
    this.node.indeterminate = false;

    this.changeDetector.markForCheck();

    this.children.forEach((child) => child.toggle(checked));
  }

  trackByNode(index: number, item: CheckboxTreeNode<T>): any {
    return this.trackBy(item.value);
  }
}
